import React from "react";
import { PORTAL_IMAGE } from "constants/imagePath";
import { Image } from "rebass";

export const LockIcon = () => <Image src={`${PORTAL_IMAGE}/login/account_lock.svg`} alt="account-lock" />;

export * from "./email";
export * from "./country";
export * from "./mobileNumber";
